import React, { ChangeEvent, useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useMutation, useQuery } from 'react-query';
import { toast } from 'react-toastify';
import { get_single_holidays, update_holiday } from '../api/holidaysApi';
import "../../../../_metronic/assets/keenicons/outline/style.css";
import DatePicker from 'react-datepicker';
import { formatDateFlatpickr, formatDateWithoutTime, formatDynamicDateTime } from '../../../helper-functions/DateFunction';
import { useGeneralSettings } from '../../../contexts/GeneralSettingsContext';
import { get_filtered_users } from '../../users/api/usersApi';
function EditHoliday() {
  const { getSettingValue } = useGeneralSettings();
  const userDateFormat = getSettingValue('date_format') || 'dd-mm-yyyy';
  const userTimeFormat = getSettingValue('time_format') || '12hr';
  const userTimeZone = getSettingValue('time_zone') || 'UTC';
  

    const [selectedHoliday, setSelectedHoliday] = useState<any | null>();
    const [titleError, setTitleError] = useState('');
    const [holidayTypeError, setHolidayTypeError] = useState('');
    const [loading, setLoading] = useState(false);
    const location = useLocation();
    const id = (location.state as { id: number }).id;
    const [users, setUsers] = useState<any[]>([]);
    const [selectedUserId, setSelectedUserId] = useState<number | ''>('');
    const [selectedUserName, setSelectedUserName] = useState<string | ''>('');
    const { data: viewHoliday, isLoading: viewHolidayIsLoading, error: viewHolidayIsError } = useQuery(['ViewHoliday', id, { refetchOnWindowFocus: false }], () =>
        get_single_holidays(id)
    );
    useEffect(() => {
        if (viewHoliday) {
            setSelectedHoliday(viewHoliday.data);
        }
    }, [viewHoliday]);
    const navigate = useNavigate();
    const { refetch: refetchUsers } = useQuery(
        ['filteredUsers'],
        () => get_filtered_users('', 1, 100),
        {
            onSuccess: (res) => {
                const usersList = res.data?.data?.data || [];
                setUsers(usersList);
            },
            onError: () => {
                toast.error('Failed to load users', {
                    position: 'top-right',
                    autoClose: 3000,
                });
            },
        }
    );
    // Onchange Handler
    const handleTitleChange = (e: ChangeEvent<HTMLInputElement>) => {
        if (selectedHoliday) {
            const newTitleName = e.target.value;
            if (!newTitleName) {
                setTitleError('Holiday is required.');
            } else {
                setTitleError('');
            };
            setSelectedHoliday({
                ...selectedHoliday,
                title: newTitleName,
            });
        };
    };
    const handleLocationChange = (e: ChangeEvent<HTMLSelectElement>) => {
        if (selectedHoliday) {
            const newlocation = e.target.value;
            setSelectedHoliday({
                ...selectedHoliday,
                location_id: newlocation,
            });
        };
    };
    const handleShiftChange = (e: ChangeEvent<HTMLSelectElement>) => {
        if (selectedHoliday) {
            const newShift = e.target.value;
            setSelectedHoliday({
                ...selectedHoliday,
                location_shift_id: newShift,
            });
        };
    };
    const handleDescriptionChange = (e: ChangeEvent<HTMLTextAreaElement>) => {
        if (selectedHoliday) {
            const newdescription = e.target.value;
            setSelectedHoliday({
                ...selectedHoliday,
                description: newdescription,
            });
        };
    };
    const handleFromDateChange = (date) => {
        setSelectedHoliday({
            ...selectedHoliday,
            from_date: formatDateFlatpickr(date),
        });
    };

    const handleToDateChange = (date) => {
        setSelectedHoliday({
            ...selectedHoliday,
            to_date: formatDateFlatpickr(date),
        });
    };
    const handleUserChange = (e: ChangeEvent<HTMLSelectElement>) => {
        const userId = e.target.value ? Number(e.target.value) : '';
        setSelectedUserId(userId);
        setSelectedHoliday({ ...selectedHoliday, user_id: userId });
    };
    // Updated handleUpdateHoliday function
    const handleUpdateHoliday = () => {
        setLoading(true);
        if (!selectedHoliday) {
            toast.error('No holiday type selected for update', {
                position: 'top-right',
                autoClose: 3000,
            });
            setLoading(false);
            return;
        }
        const {
            id,
            title,
            holiday_type_id,
            from_date,
            to_date,
            description,
            location_id,
            location_shift_id,
            user_id
        } = selectedHoliday;
        const requestData = {
            id,
            data: {
                title: title,
                holiday_type_id: holiday_type_id,
                from_date: from_date,
                to_date: to_date,
                description: description,
                location_id: location_id,
                location_shift_id: location_shift_id,
                user_id: selectedUserId || user_id || null,
            }
        };
        updateHolidayMutation.mutate(requestData);
    };
    const updateHolidayMutation = useMutation((data: any) => update_holiday(data.id, data.data), {
        onSuccess: (response) => {
            setLoading(false);
            navigate('/holidays/list');
            toast.success(response.message, {
                position: 'top-right',
                autoClose: 3000,
            });
        },
        onError: (error: any) => {
            if (error.response) {
                toast.error(error.response.data.message, {
                    position: "top-right",
                    autoClose: 3000,
                });
                setLoading(false);
            } else if (error.request) {
                // The request was made but no response was received
                toast.error('No response received from the server.', {
                    position: "top-right",
                    autoClose: 3000,
                });
                setLoading(false);
            } else {
                toast.error('An unexpected error occurred.', {
                    position: "top-right",
                    autoClose: 3000,
                });
            }
            setLoading(false);
        },
    });
    if (viewHolidayIsLoading) {
        return (
            <div className='text-center'>
                <div className='spinner-border' role='status'>
                    <span className='visually-hidden'>Loading...</span>
                </div>
            </div>
        );
    }
    if (viewHolidayIsError) {
        return (
            <div className='text-center'>
                <h2>Error in Get All Holidays</h2>
            </div>
        );
    };
    const mapDateFormat = (format: string) => {
        return format
            .replace(/dd/g, "dd")
            .replace(/mm/g, "MM")
            .replace(/yyyy/g, "yyyy");
    };
    return (
        <div className='card mb-5 mb-xl-10'>
            <div
                className='card-header border-0'
                data-bs-toggle='collapse'
                data-bs-target='#kt_account_profile_details'
                aria-expanded='true'
                aria-controls='kt_account_profile_details'
            >
                <h3 className='card-title align-items-start flex-column'>
                    <span className='card-label fw-bolder fs-3 mb-1'>Edit Holiday</span>
                </h3>
                <div
                    className='card-toolbar'
                    data-bs-toggle='tooltip'
                    data-bs-placement='top'
                    data-bs-trigger='hover'
                >
                    <button
                        data-toggle="tooltip" data-placement="bottom" title="Navigate to List holidays"
                        className='btn btn-sm btn-light-dark fs-5'
                        onClick={() => navigate('/holidays/list')}
                    >
                        List of Holidays
                    </button>
                </div>
            </div>
            <div id='kt_account_profile_details' className='collapse show'>
                <div className='card-body border-top p-9'>
                    {selectedHoliday ? (
                        <>
                            {/* User Dropdown */}
                            <div className="row mb-6">
                                <label className="col-lg-4 col-form-label fw-bold fs-6">
                                    <span>User {selectedHoliday.holiday_for}</span>
                                </label>
                                <div className="col-lg-8 fv-row">
                                    <select
                                        className="form-select form-select-solid"
                                        value={selectedHoliday.user_id}
                                        onChange={handleUserChange}
                                    >
                                        <option value="">For All Users</option>
                                        {users.map((user) => (
                                            <option key={user.id} value={user.id}>
                                                {user.fullname}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                            </div>
                            <div className='row mb-6'>
                                <label className='col-lg-4 col-form-label fw-bold fs-6'>
                                    <span className='required'>Holiday</span>
                                </label>
                                <div className='col-lg-8 fv-row'>
                                    <input
                                        type='text'
                                        className='form-control form-control-lg form-control-solid'
                                        value={selectedHoliday ? selectedHoliday.title : ''}
                                        onChange={(e) => handleTitleChange(e)}
                                    />
                                    {titleError && (
                                        <div className='text-danger'>{titleError}</div>
                                    )}
                                </div>
                            </div>
                            <div className='row mb-6'>
                                <label className='col-lg-4 col-form-label fw-bold fs-6'>
                                    <span className='required'>From Date</span>
                                </label>
                                <div className='col-lg-8 react-datepicker-wrapper-input-box fv-row'>
                                    <DatePicker
                                        selected={selectedHoliday ? new Date(Date.parse(selectedHoliday.from_date)) : null}
                                        onChange={(date) => handleFromDateChange(date)}
                                        className='form-control form-control-solid'
                                        dateFormat={mapDateFormat(userDateFormat)}
                                        placeholderText={formatDynamicDateTime(selectedHoliday?.from_date, userDateFormat, userTimeFormat, userTimeZone)}
                                        wrapperClassName="w-100"
                                    />
                                </div>
                            </div>
                            <div className='row mb-6'>
                                <label className='col-lg-4 col-form-label fw-bold fs-6'>
                                    <span className='required'>To Date</span>
                                </label>
                                <div className='col-lg-8 react-datepicker-wrapper-input-box fv-row'>
                                    <DatePicker
                                        selected={selectedHoliday ? new Date(Date.parse(selectedHoliday.to_date)) : null}
                                        onChange={(date) => handleToDateChange(date)}
                                        className='form-control form-control-solid'
                                        dateFormat={mapDateFormat(userDateFormat)}
                                        placeholderText={formatDynamicDateTime(selectedHoliday?.to_date, userDateFormat, userTimeFormat, userTimeZone)}
                                        minDate={selectedHoliday ? new Date(selectedHoliday.from_date) : undefined}
                                        wrapperClassName="w-100"
                                    />
                                </div>
                            </div>

                            <div className='row mb-6'>
                                <label className='col-lg-4 col-form-label fw-bold fs-6'>
                                    <span>Description</span>
                                </label>
                                <div className='col-lg-8 fv-row'>
                                    <textarea
                                        className='form-control form-control-lg form-control-solid'
                                        value={selectedHoliday ? selectedHoliday.description : ''}
                                        onChange={(e) => handleDescriptionChange(e)}
                                    />
                                </div>
                            </div>
                        </>
                    ) : null}
                </div>
                <div className='card-footer d-flex justify-content-end py-6 px-9'>
                    <button
                        data-toggle="tooltip"
                        data-placement="bottom"
                        title="Update holiday"
                        type='button'
                        className='btn btn-primary'
                        onClick={handleUpdateHoliday}
                        disabled={loading || titleError !== '' || holidayTypeError !== ''}
                    >
                        {!loading && 'Update holiday'}
                        {loading && (
                            <span className='indicator-progress d-block'>
                                Please wait...{' '}
                                <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                            </span>
                        )}
                    </button>
                </div>
            </div>
        </div>
    )
}
export default EditHoliday;